/**
 * @module app.draw.drawDirective
 */
/**
 * @fileoverview This file provides a draw directive. This directive is used
 * to create a draw panel in the page.
 *
 * Example:
 *
 * <app-draw app-draw-map="::mainCtrl.map"
 *           app-draw-active="mainCtrl.drawOpen"></app-draw>
 *
 * Note the use of the one-time binding operator (::) in the map expression.
 * One-time binding is used because we know the map is not going to change
 * during the lifetime of the application.
 */

import appModule from '../module.js';

/**
 * @param {string} appDrawTemplateUrl Url to draw template
 * @return {angular.Directive} The Directive Definition Object.
 * @ngInject
 */
const exports = function(appDrawTemplateUrl) {
  return {
    restrict: 'E',
    scope: {
      'map': '=appDrawMap',
      'active': '=appDrawActive',
      'activateMymaps': '=appDrawActivateMymaps',
      'mymapsOpen': '=appDrawMymapsOpen',
      'feedbackcruesOpen': '=appDrawFeedbackCruesOpen',
      'feedbackanfOpen': '=appDrawFeedbackAnfOpen',
      'feedbackageOpen': '=appDrawFeedbackAgeOpen'
    },
    controller: 'AppDrawController',
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: appDrawTemplateUrl
  };
};


appModule.directive('appDraw', exports);


export default exports;
